import { ArrowDown, ArrowLeft, ArrowRight, RotateCw, ChevronDown } from 'lucide-react';

interface MobileControlsProps {
  onLeft: () => void;
  onRight: () => void;
  onDown: () => void;
  onRotate: () => void;
  onHardDrop: () => void;
}

export function MobileControls({ onLeft, onRight, onDown, onRotate, onHardDrop }: MobileControlsProps) {
  return (
    <div className="flex justify-center gap-3 mt-4 md:hidden">
      <button
        onTouchStart={(e) => { e.preventDefault(); onLeft(); }}
        className="w-14 h-14 rounded-xl bg-primary/20 flex items-center justify-center active:bg-primary/40 transition-colors"
      >
        <ArrowLeft className="w-6 h-6 text-primary-foreground" />
      </button>
      <button
        onTouchStart={(e) => { e.preventDefault(); onDown(); }}
        className="w-14 h-14 rounded-xl bg-primary/20 flex items-center justify-center active:bg-primary/40 transition-colors"
      >
        <ArrowDown className="w-6 h-6 text-primary-foreground" />
      </button>
      <button
        onTouchStart={(e) => { e.preventDefault(); onRotate(); }}
        className="w-14 h-14 rounded-xl bg-primary/20 flex items-center justify-center active:bg-primary/40 transition-colors"
      >
        <RotateCw className="w-6 h-6 text-primary-foreground" />
      </button>
      <button
        onTouchStart={(e) => { e.preventDefault(); onRight(); }}
        className="w-14 h-14 rounded-xl bg-primary/20 flex items-center justify-center active:bg-primary/40 transition-colors"
      >
        <ArrowRight className="w-6 h-6 text-primary-foreground" />
      </button>
      <button
        onTouchStart={(e) => { e.preventDefault(); onHardDrop(); }}
        className="w-14 h-14 rounded-xl bg-accent/30 flex items-center justify-center active:bg-accent/50 transition-colors"
      >
        <ChevronDown className="w-6 h-6 text-accent" />
      </button>
    </div>
  );
}
